 import { get } from '@/utils/request'


export function getPayslips(params) {
    return get('api/mobile/payslips/', params)
}